import axios from 'axios'

const fetchPisto = axios.create({
    //baseURL: 'https://www.thecocktaildb.com/api/json/v1/1/random.php'
    baseURL: 'https://www.thecocktaildb.com/api/json/v1/1'
})

export default fetchPisto